'use strict';

const geocode = require('./geocode');
const addEditAddress = require('./addEditAddressTab');

let $lockerTab = null;
let $lockerTabContent = null;
let $lockerInput = null;
let $lockerButton = null;
let $lockerLabel = null;
let $notificationMessage = null;
let $notificationContainer = null;
let $emptyStateHint = null;
let $globalAddressDetails = null;

/**
 * Shows informative errors
 * @requires jQuery
 * @param {String} message - Error text
 * @param {Boolean} [clearStoreList=true] - Whether to clear the list group, default is true
 * @returns {void}
 */
function showError(message, clearStoreList = true) {
    $notificationMessage.text(message);
    $notificationContainer.removeClass('d-none');
    $lockerButton.attr('disabled', true);
    $emptyStateHint.addClass('d-none');

    if (clearStoreList) {
        $lockerTabContent.find('.list-group').empty();
    }
}

/**
 * Removes informative errores
 * @requires jQuery
 * @returns {void}
 */
function clearErrors() {
    $notificationMessage.text('');
    $notificationContainer.addClass('d-none');
}

/**
 * Renders an address that is out of coverage
 * @requires jQuery
 * @param {Object} address - The address object
 * @returns {void}
 */
function renderNotCoverageAddress(address) {
    const $container = $lockerTabContent.find('.list-group');
    const iconURL = $container.attr('data-not-in-range-icon');

    const $newChild = $(`
        <div class="list-group-item list-group-item-action not-in-range">
            <div>                    
                <img src="${iconURL}" alt="location" />
            </div>
            <div>
                <h6 class="item-title">${address.name}</h6>
                <p class="item-text">${address.addressDetails}</p>
            </div>
        </div>
    `);
    $container.append($newChild);
}


/**
 * Function that handles error in geolocation
 * @requires jQuery
 * @returns {void}
 */
function setLocationError() {
    showError($lockerTabContent.find('.current-location-link').data('error'));
}

/**
 * Reset inputs and result elements
 * @requires jQuery
 * @returns {void}
 */
function reset() {
    $lockerInput.val('');
    $lockerButton.addClass('d-none');
    $lockerTabContent.find('.list-group').empty();
    $lockerLabel.addClass('d-none');
    $emptyStateHint.removeClass('d-none');
    clearErrors();
}

/**
 * Opens the locker tab
 * @requires jQuery
 * @returns {void}
 */
function openTab() {
    $lockerTab.addClass('active');
    $lockerTab.parent('.nav-item').addClass('active');
    $lockerTabContent.addClass('show active');
}

/**
 * Closes the locker tab
 * @requires jQuery
 * @returns {void}
 */
function closeTab() {
    $lockerTab.removeClass('active');
    $lockerTabContent.removeClass('show active');
}

/**
 * Clears the search input
 * @requires jQuery
 * @returns {void}
 */
function handleClearIconClick() {
    const $input = $(this).siblings('input')
    $input.val('');
    $input.focus();
}

/**
 * Render stores found
 * @requires jQuery
 * @param {Array} stores Stores found
 * @returns {void}
 */
function handleStoresLoaded(stores) {
    const $container = $lockerTabContent.find('.list-group');
    $container.empty();

    if (!stores.length) {
        const selectedDeliveryAddress = addEditAddress.getSelectedDeliveryAddressModel($globalAddressDetails);        
        $lockerButton.addClass('d-none');
        $lockerLabel.removeClass('d-none');
        $lockerLabel.text($lockerLabel.attr('data-out-range-text'));
        $emptyStateHint.removeClass('d-none');
        renderNotCoverageAddress(selectedDeliveryAddress);
        showError($container.attr('data-error-nostores'), false);
        return;
    }

    $lockerButton.removeClass('d-none');
    $lockerLabel.removeClass('d-none');
    $lockerLabel.text($lockerLabel.attr('data-default-text'));
    $emptyStateHint.addClass('d-none');

    const selectedItemIconURL = $container.attr('data-selected-item-icon-url');
    const itemIconURL = $container.attr('data-item-icon-url');
    const $elements = stores.map((store) => {
        return `
            <div class="list-group-item list-group-item-action" data-id=${store.ID}>
                <div>
                    <img src="${itemIconURL}" alt="location" />
                </div>
                <div>
                    <h6 class="item-title">${store.name}</h6>
                    <p class="item-text">${store.address1}</p>
                </div>
            </div>`
    });

    $container.append($elements);

    $container.find('.list-group-item').on('click', function () {
        //Reset selected status
        $container.find('.list-group-item').removeClass('item-selected');
        $container.find('.list-group-item img').attr('src', itemIconURL);
        //Selects store clicked
        const $this = $(this);
        $this.find('img').attr('src', selectedItemIconURL);
        $this.addClass('item-selected');
        $lockerButton.attr('disabled', false);
    });
}

/**
 * Handler when address is geocoded
 * @requires jQuery
 * @param {Object} address Address object
 * @param {string} latitude Browser latitude
 * @param {string} longitude Browsert longitude
 * @returns {void}
 */
function addressFound(address, latitude, longitude) {
    if (!address) {
        showError($('.tab-content').attr('data-location-error'));
        return;
    }

    $lockerInput.val(address.addressDetails);
    searchCloseStores(latitude, longitude);
}

/**
 * Ajax request for searching close stores to the user device
 * @requires jQuery
 * @param {string} lat Browser latitude
 * @param {string} lng Browsert longitude
 * @returns {void}
 */
function searchCloseStores(lat, lng) {
    if (!lat || !lng) {
        return;
    }

    clearErrors();
    $lockerButton.addClass('d-none');
    $emptyStateHint.removeClass('d-none');

    $.ajax({
        url: $lockerInput.attr('data-url'),
        type: 'get',
        dataType: 'json',
        data: {
            lat,
            lng
        },
        success: function (data) {
            handleStoresLoaded(data?.stores);
        },
        error: function (err) {
            showError(JSON.parse(err.responseText).message);
        }
    });
}

/**
 * Sets the selected store as fulfillment store
 * @requires jQuery
 * @returns {void}
 */
function handlelockerButtonClick() {
    clearErrors();
    const $selectedElement = $lockerTabContent.find('.list-group-item.item-selected');

    if (!$selectedElement.length) {
        return;
    }

    $.ajax({
        url: $lockerButton.attr('data-url'),
        type: 'post',
        dataType: 'json',
        data: {
            storeID: $selectedElement.attr('data-id')
        },
        success: function (response) {
            if(response.success) {
                const $deliveryModal = $('#deliveryModal');
                const successLockerChangeUrl = $deliveryModal.attr('data-success-redirect-url');

                if (successLockerChangeUrl) {
                    window.location.href = successLockerChangeUrl;
                } else {
                    window.location.reload();
                }
            }
            else {
                showError(response.errorMsg);
            }
        },
        error: function (err) {
            showError(JSON.parse(err.responseText).message);
        }
    });
}

/**
 * Renders the saved store
 * @requires jQuery
 * @param {Object} address address
 * @returns {void}
 */
function renderSelectedStore(address) {
    const $container = $lockerTabContent.find('.list-group');
    const iconURL = $container.attr('data-selected-item-icon-url');

    const $newChild = $(`
        <div class="list-group-item list-group-item-action item-selected delivery-selected">
            <div>                    
                <img src="${iconURL}" alt="location" />
            </div>
            <div>
                <h6 class="item-title">${address.addressName}</h6>
                <p class="item-text">${address.addressDetails}</p>
            </div>
        </div>
    `);
    $container.append($newChild);

    $lockerLabel.removeClass('d-none');
    $lockerLabel.text($lockerLabel.attr('data-selected-delivery-text'));
    $lockerButton.removeClass('d-none');
    $lockerButton.attr('disabled', true);
    $emptyStateHint.addClass('d-none');
}

/**
* HandleDeliveryPlaceChanged
* @requires jQuery
* @param {Object} autocomplete Google autocomplete
* @returns {void}
**/
function handleDeliveryPlaceChanged (autocomplete) {
    const place = autocomplete.getPlace();
    $globalAddressDetails = place;

    if (place.geometry) {
        searchCloseStores(place.geometry.location.lat(), place.geometry.location.lng())
    }
    else {
        showError($lockerInput.attr('data-error-geometry'));
    }
}

/**
* This function starts the engine for the autocomplete suggestions in the locker address input
* @requires jQuery
* @returns {void}
**/
function initAutocomplete() {
    geocode.initAutocomplete($lockerInput, handleDeliveryPlaceChanged);
}

/**
 * Initialize the locker tab
 * @requires jQuery
 * @param {jQuery} $modal modal jquery object
 * @returns {void}
 */
function initTab($modal) {
    //Gets the container
    $lockerTabContent = $modal.find('#locker-tab-pane').first();
    //Assigns elements to variables
    $lockerTab = $modal.find('#locker-tab').first();
    $lockerInput = $('.input-locker').first();
    $lockerButton = $('.change-locker-address').first();
    $emptyStateHint = $('.empty-state-hint.locker').first();
    $lockerLabel = $('.locker-label').first();
    $notificationContainer = $lockerTabContent.find('.notification--error').first();
    $notificationMessage = $lockerTabContent.find('.notification-message').first();
    //Clear icon event
    $lockerTabContent.find('.clear-icon').on('click', handleClearIconClick);
    //Submit event
    $lockerButton.on('click', handlelockerButtonClick);

    return $lockerTab;
}

module.exports = {
    initTab,
    initAutocomplete,
    openTab,
    closeTab,
    clearErrors,
    reset,
    addressFound,
    setLocationError,
    renderSelectedStore
}
